/**
 * Created by gavorhes on 12/10/2015.
 */

import {LayerBaseVectorGeoJson} from './webmapsjsdist/LayerBaseVectorGeoJson';
import mapPopup from './webmapsjsdist/mapPopup';
import * as tipLayerStyles from './tipStyleFunction';
import {TipSliders} from "./webmapsjsdist/Sliders";
import $ = require('jquery');

/**
 * Tip Segment layer with a bunch of configuration applied, extends base GeoJSON
 */
export class TipSegmentLayer extends LayerBaseVectorGeoJson{
    _$loadingGif: JQuery;
    sliders: TipSliders;
    // layer: LayerBaseVectorGeoJson;

    constructor(sliders, options) {

        options['name'] = "TIP Segments";
        options.onDemand = true;
        options.style = tipLayerStyles.tipStyle;
        options['minZoom'] = typeof options.minZoom == 'number' ? options.minZoom: 10;
        options['transform'] = {};
        options.transform.dataProjection = 'EPSG:3857';
        options.transform.featureProjection = 'EPSG:3857';
        options['id'] = 'tip-segments';

        // this.layer = new LayerBaseVectorGeoJson('tip/gettipfeatures?callback=?', options);

        super()

        super('tip/gettipfeatures?callback=?', options);

        this._$loadingGif = options.$loadingGif;

        this.legendContent += '<ul><li><hr class="cell-min"></li><li><hr class="cell-very-low"></li>' +
            '<li><hr class="cell-low"></li><li><hr class="cell-mid"></li><li><hr class="cell-high"></li>' +
            '<li><hr class="cell-very-high"></li><li><hr class="cell-max">' +
            '</li></ul>';

        this.legendContent += '<ul>';
        this.legendContent += '<li style="height: 15px;">low</li>';
        this.legendContent += '<li style="height: 25px; margin-top: 4px;">medium</li>';
        this.legendContent += '<li style="height: 15px; margin-top: 5px;">high</li>';
        this.legendContent += '</ul>';

        this.legendContent += '<span style="margin: 12px 0 0 52px; display: block">Relative Need</span>';

        this.sliders = sliders;

        mapPopup.addVectorPopup(this, (props) => {

            let parms = {
                pdpId: props['p'],
                paramWeights: JSON.stringify(this.sliders.getParams())
            };

            return '<iframe style="margin-top:5px;" ' +
                `src="tip/getsegprops?${$.param(parms)}" ` +
                `height="250" width="350"></iframe>`;
        }, options.selectionStyle);
    }

    /**
     * override base method to include show or hide loading indicator
     * @param {number} zoom
     * @param {string} [evtType=undefined] undefined for initial load, otherwise one of 'change:center', 'change:resolution'
     * @returns {boolean}
     */
    mapMoveBefore(zoom, evtType) {
        let returnVal = super.mapMoveBefore(zoom, evtType);

        if (this._$loadingGif) {
            if (returnVal) {
                this._$loadingGif.fadeIn();
            } else {
                this._$loadingGif.fadeOut();
            }
        }
        return returnVal;
    }

    /**
     * callback to generate the parameters passed in the get request
     * @param {object} extent
     * @param {number} extent.minX
     * @param {number} extent.minY
     * @param {number} extent.maxX
     * @param {number} extent.maxY
     * @param {number} zoomLevel
     */
    mapMoveMakeGetParams(extent, zoomLevel) {
        super.mapMoveMakeGetParams(extent, zoomLevel);
        $.extend(this.mapMoveParams, extent);
        let selectedParams = this.sliders.paramWeightsRegionVersion;

        this.mapMoveParams['param_weights'] = JSON.stringify(selectedParams.paramWeights);
        this.mapMoveParams['region'] = selectedParams.region;
        this.mapMoveParams['version'] = selectedParams.mmVersion;

    }

    /**
     * callback function on map move
     * @param d the json response
     */
    mapMoveCallback(d) {
        super.mapMoveCallback(d);
        if (this._$loadingGif) {
            this._$loadingGif.fadeOut();
        }
    }
}


